export default "__VITE_PUBLIC_ASSET__9f882761__"